/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EarnClaimPolicyResponse
 */
export interface EarnClaimPolicyResponse {
    /**
     * Platforms this objective accepts right now. One entry means the form locks to it.
     * @type {Array<string>}
     * @memberof EarnClaimPolicyResponse
     */
    acceptedPlatforms: Array<string>;
    /**
     * POST only — a qualifying post carries any one of these.
     * @type {Array<string>}
     * @memberof EarnClaimPolicyResponse
     */
    requiredHashtags: Array<string>;
    /**
     * LIKE only — the one post that pays right now (the newest authored entry). Never an account link. Empty means any post on an accepted platform.
     * @type {Array<string>}
     * @memberof EarnClaimPolicyResponse
     */
    targetPostUrls: Array<string>;
    /**
     * FOLLOW only — the account to open, from the objective's own url field.
     * @type {string}
     * @memberof EarnClaimPolicyResponse
     */
    accountUrl?: string;
    /**
     * Campaign copy for above the form; absent means the widget writes its own line.
     * @type {string}
     * @memberof EarnClaimPolicyResponse
     */
    instructions?: string;
    /**
     * Credited claims per member this period. Absent is uncapped.
     * @type {number}
     * @memberof EarnClaimPolicyResponse
     */
    maxClaimsPerPeriod?: number;
    /**
     * What this member has already claimed against this objective in the current period.
     * @type {number}
     * @memberof EarnClaimPolicyResponse
     */
    claimsThisPeriod: number;
    /**
     * Present only when capped — maxClaimsPerPeriod minus claimsThisPeriod, floored at zero.
     * @type {number}
     * @memberof EarnClaimPolicyResponse
     */
    remainingClaims?: number;
}

/**
 * Check if a given object implements the EarnClaimPolicyResponse interface.
 */
export function instanceOfEarnClaimPolicyResponse(value: object): value is EarnClaimPolicyResponse {
    if (!('acceptedPlatforms' in value) || value['acceptedPlatforms'] === undefined) return false;
    if (!('requiredHashtags' in value) || value['requiredHashtags'] === undefined) return false;
    if (!('targetPostUrls' in value) || value['targetPostUrls'] === undefined) return false;
    if (!('claimsThisPeriod' in value) || value['claimsThisPeriod'] === undefined) return false;
    return true;
}

export function EarnClaimPolicyResponseFromJSON(json: any): EarnClaimPolicyResponse {
    return EarnClaimPolicyResponseFromJSONTyped(json, false);
}

export function EarnClaimPolicyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EarnClaimPolicyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'acceptedPlatforms': json['acceptedPlatforms'],
        'requiredHashtags': json['requiredHashtags'],
        'targetPostUrls': json['targetPostUrls'],
        'accountUrl': json['accountUrl'] == null ? undefined : json['accountUrl'],
        'instructions': json['instructions'] == null ? undefined : json['instructions'],
        'maxClaimsPerPeriod': json['maxClaimsPerPeriod'] == null ? undefined : json['maxClaimsPerPeriod'],
        'claimsThisPeriod': json['claimsThisPeriod'],
        'remainingClaims': json['remainingClaims'] == null ? undefined : json['remainingClaims'],
    };
}

export function EarnClaimPolicyResponseToJSON(json: any): EarnClaimPolicyResponse {
    return EarnClaimPolicyResponseToJSONTyped(json, false);
}

export function EarnClaimPolicyResponseToJSONTyped(value?: EarnClaimPolicyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'acceptedPlatforms': value['acceptedPlatforms'],
        'requiredHashtags': value['requiredHashtags'],
        'targetPostUrls': value['targetPostUrls'],
        'accountUrl': value['accountUrl'],
        'instructions': value['instructions'],
        'maxClaimsPerPeriod': value['maxClaimsPerPeriod'],
        'claimsThisPeriod': value['claimsThisPeriod'],
        'remainingClaims': value['remainingClaims'],
    };
}

